/**
 * The server's refusal for want of the AI consent, read by its marker (#398, #399, CS-D19).
 *
 * With the server's consent enforcement on, an interactive AI route (today the coach's chat turn) answers
 * **403** with `{"detail": <sentence>, "reason": "ai_consent_required"}` at the top level, before the
 * response starts: nothing was stored and no model was asked. The marker is the `reason`, matched
 * exactly; the status alone is not enough, because the same status is also:
 *
 * - an account pending deletion (`403` with a NESTED `detail` object and no top-level `reason`), and
 * - the Health routes' own refusal (`reason: "health_consent_required"`, which the web never meets).
 *
 * It is told apart from the spent budget's 429 (`reason: "ai_budget_spent"`, `budgetSpent.ts`) and the
 * limiter's 429 (`{"detail"}` only) by the status as well as the reason, so one can never be read as
 * another. `detail` is an English sentence for logs and support, not UI copy: the screens say their own
 * words (`COPY.aiConsentRefused`).
 */

/** The marker, as the server writes it (`api/platform/ai_consent.py`, `REASON`). */
export const AI_CONSENT_REQUIRED = 'ai_consent_required'

/** True when this answer is the AI consent's refusal: a 403 whose body carries the marker. */
export function isAiConsentRefusal(status: number, bodyText: string): boolean {
  if (status !== 403) return false
  let body: unknown
  try {
    body = JSON.parse(bodyText)
  } catch {
    return false
  }
  if (body === null || typeof body !== 'object' || Array.isArray(body)) return false
  return (body as { reason?: unknown }).reason === AI_CONSENT_REQUIRED
}
